<template>
  <div class="container">
    <div class="title"><h2>预约科目</h2></div>
    <div class="section">
      <h4>预约考试等级 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.examRank}}
      </div>
      <div class="from_check" style="margin-top:-12px">
        <div class="mask"></div>
        <van-checkbox-group v-model="studentDetails.subjectArray" disable>
          <van-checkbox
            v-for="(item,index) in subjectArray"
            :key="index"
            style="margin:10px 0" 
            :name="item.name"
            checked-color="#1989fa" 
            shape="square"
          >
            {{item.name}}（{{item.price}}元）
          </van-checkbox>
        </van-checkbox-group>
      </div>  
    </div>
    <template v-if="theoryAppointment.time">
      <div class="title_child"><h4>预约理论考试</h4></div>
      <div class="section">
        <h4>预约考试地点</h4>
        <div class="from_input">
          {{theoryAppointment.address}}
        </div>
        <h4 style="margin-top:-14px">预约考试时间</h4>
        <div class="from_input">
          {{theoryAppointment.time}}
        </div>
      </div>
    </template>
    <template v-if="operationAppointment.time">
      <div class="title_child"><h4>预约实操考试</h4></div>
      <div class="section">
        <h4>预约考试地点</h4>
        <div class="from_input">
          {{operationAppointment.address}}
        </div>
        <h4 style="margin-top:-14px">预约考试时间</h4>
        <div class="from_input">
          {{operationAppointment.time}}
        </div>
      </div>
    </template>
 
 
    <div class="title"><h2>预约信息</h2></div>
    <div class="section">
      <h4>姓名 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.examName}}
      </div>
 
      <h4>证件类型 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.examCardStatus}}
      </div>
 
      <h4>证件号码 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.examCard}}
      </div>
 
      <h4>出生日期</h4>
      <div class="from_input">
        {{studentDetails.birthdate}}
      </div>
 
      <h4>性别 <span class="red">*</span></h4>
      <div class="from_check" style="margin:10px 0 20px 0">
        <div class="mask"></div>
        <van-radio-group v-model="studentDetails.examSex" direction="horizontal">
          <van-radio name="男">男</van-radio>
          <van-radio name="女">女</van-radio>
        </van-radio-group>
      </div>
 
      <h4>民族</h4>
      <div class="from_input">
        {{studentDetails.nation}}
      </div>
 
      <h4>政治面貌 </h4>
      <div class="from_input">
        {{studentDetails.politicsstatus}}
      </div>
 
      <h4>所属群体 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.referenceGroup}}
      </div>
 
      <h4>工作单位 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.workunit}}
      </div>
 
      <h4>职业年限（年） <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.term}}
      </div>
 
      <h4>现居地址 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.currentaddress + filterData(studentDetails.downtown)}}
      </div>
 
      <h4>邮政编码</h4>
      <div class="from_input">
        {{studentDetails.postalcode}}
      </div>
 
      <h4>从事职业</h4>
      <div class="from_input">
        {{studentDetails.engineer}}
      </div>
 
      <h4>参加工作日期</h4>
      <div class="from_input">
        {{studentDetails.dateofentry}}
      </div>
      
      <h4>身份信息</h4>
      <div class="from_input">
        {{studentDetails.identity}}
      </div>
 
      <h4>职业 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.profession}}
      </div>
 
      <h4>鉴定分类 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.classification}}
      </div>
 
      <h4>手机号码 <span class="red">*</span></h4>
      <div class="from_input" style="margin-bottom:5px">
        {{studentDetails.examPhone}}
      </div>
    </div>
 
    <div class="title"><h2>预约条件</h2></div>
    <div class="section">
 
      <h4>申报条件 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.acceptance}}
      </div>
 
      <h4>文化程度 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.examRecord}}
      </div>
 
      <h4>毕业时间 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.examGetTime}}
      </div>
 
      <h4>毕业学校 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.schoolTag}}
      </div>
 
      <h4>毕业证书 <span class="red">*</span></h4>
      <div class="form_file">
        <div>
          <file-box
            headert="毕业证书"
            fileName="毕业证书.PDF"
            :mainup="studentDetails.diploma"
          ></file-box>
          </div>
      </div>
 
      <h4>社保记录 </h4>
      <div class="form_file">
        <div>
          <file-box
            headert="社保记录"
            fileName="社保记录.PDF"
            :mainup="studentDetails.socialSecurity"
          ></file-box>
          </div>
      </div>
 
      <h4>上传工作经验及证明文件 <span class="red">*</span></h4>
      <div class="form_file">
        <div>
          <file-box
            headert="工作证明"
            fileName="工作证明.PDF"
            :mainup="studentDetails.certificate"
          ></file-box>
          </div>
      </div>
 
      <h4>身份证（正反面） <span class="red">*</span></h4>
      <div class="form_file">
        <div>
          <file-box
            headert="身份证扫描件"
            fileName="身份证扫描件.PDF"
            :mainup="studentDetails.cardpositive"
          ></file-box>
          </div>
      </div>
 
      <h4>本人证件照 <span class="red">*</span></h4>
      <div class="form_file">
        <div>
          <file-box
            headert="本人证件照"
            fileName="证件照.JPG"
            :mainup="studentDetails.examIdentificationImg"
          ></file-box>
          </div>
      </div>
 
      <h4>报名申报表 <span class="red">*</span></h4>
      <div class="form_file">
        <div>
          <file-box
            headert="报名申报表"
            fileName="报名申报表.PDF"
            :mainup="studentDetails.registrationForm"
          ></file-box>
          </div>
      </div>
 
      <h4>学信网验证报告 <span class="red">*</span></h4>
      <div class="form_file">
        <div>
          <file-box
            headert="学信网验证报告"
            fileName="学信网验证报告.PDF"
            :mainup="studentDetails.xuexinelectronic"
          ></file-box>
          </div>
      </div>
      <h4>职业技能/职业资格/职称证书</h4>
      <div class="form_file">
        <div>
          <file-box
            headert="证书"
            fileName="职业技能/职业资格/职称证书.PDF"
            :mainup="studentDetails.completionCertificate"
          ></file-box>
          </div>
      </div>
 
      <h4>邮寄证书地址 <span class="red">*</span></h4>
      <div class="from_input">
        {{studentDetails.examCertificate}}
      </div>
 
      <h4>报名备注</h4>
      <div class="from_input" style="margin-bottom:5px">
        {{studentDetails.remark}}
      </div>
    
    </div>
  </div>
</template>
 
<script>
import fileBox from "@/components/filebox.vue";
export default {
  components: {
    fileBox
  },
  data() {
    return{
      studentDetails: {},
      subjectArray: [],
      theoryAppointment: {},  //预约时间地点
      operationAppointment: {}
    }
  },
  created() {
    this.fetchDetails()
  },
  watch: {
    'studentDetails.examRank': function() {
      this.getSubject()
    }
  },
  methods: {
    fetchDetails: function () {
      const params = {
        id: this.$route.params.id,
      }
      this.$http.get("registration/one", {params}).then((res) => {
        if (res.data.success) {
          let data = res.data.data
          this.studentDetails = data.info
          if(data.theory && data.theory.day){
            this.theoryAppointment.time = data.theory.day + ' ' + data.theory.period
            this.theoryAppointment.address = data.theory.addressDetail
          }
          if(data.operation && data.operation.day){
            this.operationAppointment.time = data.operation.day + ' ' + data.operation.period
            this.operationAppointment.address = data.operation.addressDetail
          }
          if(this.studentDetails.subject){
            this.$set(this.studentDetails, "subjectArray", this.studentDetails.subject.split('，'))
          }
        } else {
          console.log(err);
        }
      })
      .catch((err) => console.log(err));
    },
    filterData: function(data) {
      return data || ''
    },
    getSubject: function() {
      let params = {
        examRank: this.studentDetails.examRank,
        id: this.$route.params.id,
      }
      this.$http.get('/registration/subject/list', {params}).then(res => {
        if(res.data.success) {
          this.subjectArray = res.data.data
        }
      })
    },
  }
 
}
</script>
 
 
<style scoped>
*{
  box-sizing: border-box;
  font-size: 16PX;
}
h2{
  font-size: 22PX;
}
h4{
  font-size: 16PX;
}
.section{
  box-sizing: border-box;
  padding: 30px;
  background: white;
}
 
.container{
  width: 100%;
  height: 100vh;
  background: white;
}
.title{
  width: 100%;
  height: 100px;
  background: #EEEEEE;
  padding: 20px;
}
.title_child{
  width: 100%;
  height: 80px;
  background: #EEEEEE;
  margin-top: -20px;
  padding: 20px;
}
.from_input{
  margin-top: 20px;
  width: 100%;
  min-height: 60px;
  padding-left: 12px;
  line-height: 50px;
  border: 1px solid #DCDCDC;
  cursor: default;
  margin-bottom: 28PX;
  
}
.from_check{
  position: relative;
  margin-bottom: 20px;
}
.form_file{
  position: relative;
  margin: 15px 0 40px 0;
}
.flex{
  display: flex;
}
.mask{
  width: 100%;
  height: 200px;
  position: absolute;
  z-index: 100;
}
.red{
  color: red;
}
 
</style>
